export default __webpack_public_path__ + "6ad435933004592e8a9b1ca3c15e64a4.svg";